import React from 'react';
import { Route, Routes } from 'react-router-dom'
import './App.css'; 
import './Appointment/Appointments.css';
import AppLayout from "../Layouts/AppLayout";
import useUserAccess from "../Hooks/useUserAccess";
import useScrollbarClickGuard from "../Hooks/useScrollbarClickGuard";
import AnonymousRoutes from "../Components/Routes/AnonymousRoutes";
import AuthenticatedRoutes from "../Components/Routes/AuthenticatedRoutes";
import ScreenPopContainer from "./ScreenPop/ScreenPopContainer";
import routes from "../Constants/routes";

function App({ }) {
    const {isAuthenticated} = useUserAccess();

    useScrollbarClickGuard();

    return (
        <Routes>
            {/* Outside AppLayout and the auth split: the page handles sign-in itself (auto-login). */}
            <Route path={routes.hsScreenPop} element={<ScreenPopContainer/>}/>
            <Route element={<AppLayout/>}>
                {!isAuthenticated() ? <Route path="/*" element={<AnonymousRoutes/>}/> : <Route path="/*" element={<AuthenticatedRoutes/>}/>}
            </Route>
        </Routes>
    );
}

export default App;